import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    options: {
        id: number,
        name: string
    }[];
    children: React.Element<any> | Function;
}

export class WorkTypeOptions extends React.Component<Props> {
    shouldComponentUpdate(nextProps: Props) {
        return !isEqual(this.props.options, nextProps.options);
    }

    render() {
        const { options, children } = this.props;

        if (typeof children === 'function') {
            return children(options);
        }

        return React.cloneElement(children, { options });
    }
}

const mapStateToProps = createStructuredSelector({
    options: selectOptions
});

export default connect(mapStateToProps)(WorkTypeOptions);
